import { el, mount, unmount, list } from 'redom';

import { stringToSVG } from 'utilities';
import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import {
  ToolContainer,
  MarkButton
} from './mark-buttons';

import textFormattingToolsIconString from 'assets/images/text-style-icon.svg?raw';

import listButtonToggleIconString from 'assets/images/bullet-list-toggle-icon.svg?raw';

import headingButtonsToggleIconString from 'assets/images/heading-buttons-toggle-icon.svg?raw';

import alignmentToggleIconString from 'assets/images/center-alignment-toggle-icon.svg?raw';

import toolbarColorsIconString from 'assets/images/toolbar-colors-icon.svg?raw';

import {
  setIconClasses
} from './utilities';

import './index.scss';

const textFormattingToolsIcon = stringToSVG(textFormattingToolsIconString);
const listButtonToggleIcon = stringToSVG(listButtonToggleIconString);
const headingButtonsToggleIcon = stringToSVG(headingButtonsToggleIconString);
const alignmentToggleIcon = stringToSVG(alignmentToggleIconString);
const toolbarColorsIcon = stringToSVG(toolbarColorsIconString);

setIconClasses('text-format-buttons-toggle', textFormattingToolsIcon);
setIconClasses('heading-buttons-toggle', headingButtonsToggleIcon);

class ToolbarAnchor {

  constructor(configuration) {

    this.group = configuration.group;
    this.container = this.determineContainer(configuration);
    this.icon = this.determineIcon();
    this.hideTimerReference = null;
    this.dynamicContentContainer = configuration.dynamicContentContainer;

    this.el = el('button.text-mark-buttons-main', {
      class: 'inline-toolbar-button',
      onmouseenter: this.show.bind(this),
      onmouseleave: this.tryHide.bind(this),
    }, [this.icon]);

  }

  determineContainer(configuration) {

    const container = new ToolContainer({
      anchor: this,
      buttons: list('.mark-buttons.toolbar-buttons-container', MarkButton, null, {
        onClick: configuration.onClick
      })
    });

    container.update(configuration);

    return container;

  }

  determineIcon() {

    if (this.group === 'list') {
      return listButtonToggleIcon.cloneNode(true);
    } else if (this.group === 'headings') {
      return headingButtonsToggleIcon.cloneNode(true);
    } else if (this.group === 'alignment') {
      return alignmentToggleIcon.cloneNode(true);
    } else if (this.group === 'colors') {
      return toolbarColorsIcon.cloneNode(true);
    } else {
      return textFormattingToolsIcon.cloneNode(true);
    }

  }

  show() {

    clearTimeout(this.hideTimerReference);
    mount(this.dynamicContentContainer, this.container);
    this.el.classList.add('active');
    this.container.show();

    const element = this.container.el;
    const anchorElement = this.el;
    const viewportElement = void 0;
    const verticalOffset = 5;
    const horizontalOffset = 0;
    const startSide = 'top';
    const placeOnCenter = true;
    const positionableSides = ['top', 'bottom'];

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);
    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  hide() {

    if (this.dynamicContentContainer === null) {
      return;
    }

    if (this.dynamicContentContainer.contains(this.container.el) === false) {
      return;
    }

    unmount(this.dynamicContentContainer, this.container);
    this.el.classList.remove('active');
    this.container.hide();

  }

  tryHide() {

    this.hideTimerReference = setTimeout(this.hide.bind(this), 200);

  }

  update(configuration) {

    this.container.update(configuration);

  }

}

export default ToolbarAnchor;